import { KnowledgeItemPreviewItemModel } from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { getPropertySortText } from "client/Components";
import { DataSourceSortableState, DataSourceSortDirection } from "client/Data/sorting";
import { localize } from "client_legacy/ndaw/culture";

interface SortByOption {
	value: DataSourceSortableState<KnowledgeItemPreviewItemModel>;
	text: string;
	valueTrackingId: string;
}

export const defaultSortingOption: SortByOption = {
	value: { propertyName: "viewsCount", direction: DataSourceSortDirection.Descending },
	text: localize("_MostPopular"),
	valueTrackingId: "most-popular"
};

export const sortOptions: readonly SortByOption[] = [
	defaultSortingOption,
	{
		value: { propertyName: "publicationDate", direction: DataSourceSortDirection.Descending },
		text: getPropertySortText("_PublicationDate", "_NewToOld"),
		valueTrackingId: "publication-date-new-old"
	},
	{
		value: { propertyName: "publicationDate", direction: DataSourceSortDirection.Ascending },
		text: getPropertySortText("_PublicationDate", "_OldToNew"),
		valueTrackingId: "publication-date-old-new",
	},
	{
		value: { propertyName: "title", direction: DataSourceSortDirection.Ascending },
		text: getPropertySortText("_Title", "_AToZ"),
		valueTrackingId: "title-a-z"
	},
	{
		value: { propertyName: "title", direction: DataSourceSortDirection.Descending },
		text: getPropertySortText("_Title", "_ZToA"),
		valueTrackingId: "title-z-a"
	}
];